import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import Header from "../components/header";
import Spinner from "../components/spinner";
import TopNavabr from "../components/topNavabr";
import { BASE_URL, IMAGE_BASE_URL } from "../data/baseURL";
import { useScrollTop } from "../hook/useScrollTop";
import clientBannerImg from "../images/client.jpg";

function Services() {
  const { data, isLoading } = useQuery(["services"], async () => {
    const response = await window.fetch(`${BASE_URL}/index-service-slider`);
    return await response.json();
  });

  const navigate = useNavigate();

  useScrollTop();

  if (isLoading) {
    return <Spinner />;
  }

  const services = data?.sliders;

  return (
    <>
      <TopNavabr />
      <Header bannerBackground="image" staticImageURL={clientBannerImg}>
        <div className="my-5 py-5">
          <h1 className="fs-56 text-capitalize flex align-items-center text-center header-background-image-size">
            Our Services
          </h1>
        </div>
      </Header>
      <div className="container-fluid pb-9">
        <div className="ms-13 me-13">
          <div className="container">
            <div className="mt-5">
              <h1 className="fs-56 lh-64 gilroy-bold text-center">
                Complete Portfolio of Services
              </h1>
              <p className="fs-20 lh-30 text-align-justify">
                Welcome to AFRO's complete portfolio of services and solutions
                where you can explore information about our solutions, products
                and services. Our comprehensive portfolio supports
                communications service providers to address consumers and
                enterprise needs with turn-key solutions.
              </p>
            </div>
            <div className="row">
              {services?.map((slider, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-4">
                  <div
                    className="review-shadow bg-white rounded-lg cursor-pointer transform-up my-4 position-relative pb-4"
                    onClick={() => {
                      navigate(`/service/${slider?.id}`);
                    }}
                  >
                    <div>
                      <img
                        src={`${IMAGE_BASE_URL}/${slider?.image}`}
                        alt={slider?.name}
                        style={{
                          borderRadius: "10px 10px 0 0",
                          // width: "100%",
                          // height: "35rem",
                        }}
                        className="img-fluid"
                      />
                      <div className="p-3">
                        <span>{}</span>
                        <h3 className="fs-20 my-3 text-capitalize text-charleston-green gilroy-bold">
                          {slider?.title}
                        </h3>
                        <p className="fs-16 text-secondary">
                          {slider?.short_description ||
                            "We offer a variety of fiber solutions from our towers and other connectivity services to support our customers’ digital strategies. "}
                        </p>
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="fs-16 text-secondary gilroy-bold">
                            {slider?.service_country?.length} Countries
                          </p>
                          <p className="fs-16 gilroy-bold text-secondary">
                            {slider?.site} Sites
                          </p>
                        </div>
                        <div className="review-card-border"></div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Services;
